var map = {
	"./images/brand.svg": 14717,
	"./images/guide/guideTrackStep1.png": 60971,
	"./images/login/easystoreBindBg.png": 98430,
	"./images/login/login-title.png": 86303,
	"./images/login/shopifyBindBg.png": 82019,
	"./images/login/shoplineBindBg.png": 67273,
	"./images/login/wixOc.png": 43853,
	"./images/login/woocommerceBindBg.png": 69389,
	"./images/logo.svg": 31435,
	"./images/platformIcon/oneship.svg": 50848
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84904;